module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAfCAMAAAB55NVoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0OTb2+vk2NrazNvT6enqyNHM6fLt4u7n8fTy+/z84uLj1ung8/j10dHR3u7p////RaUHsQAAAPpJREFUeNqUlFESgyAMBRNFAoTG+9+2UWxLKUH6Pp1d8oYMwj6KRyJqvsHQYNHgH4aXMxinDSyGMIc5w78MEZoyKoHjlMFvQVY3Y9BHELg3AlI1QmuFO6MeUG4YECkMDJRe0DYidw1vGyT9Gdk0+qVKra6R+6WEzRneGkGGEa1SvOwxQoc3OunqiZigIs8FkckftVA+RkZBAQAZhRneRka5CazrltIjXYbnIQzrtj1KLoNwBtYsKYC5Yj5qVLDSPl77wM7BLexC9T6ofgUte8LN3yfwRbbsL1wMj7g1pLKL89l4/9oqTRz8ZbjXsYqG/T7gklMy7tN5CjAAnMpPADvZ7xgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/VA.png
// module id = +FvM
// module chunks = 1